import axios from 'axios';

const version = 'v1';
const basePath = 'group';

export async function getAll() {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
  });
}
